$shm_hitalama_map_widget_float_settings_table $shm_hitalama_map_widget_float_settings
	controls /
		<= Settings_scroll
	controlled_settings_content /
		^ headers_label_visible / <= Headers_label $mol_labeler
			title \Заголовки
			Content <= Headers $mol_textarea
				hint \Один заголовок на строку
				value? <=> headers_text? \
				spellcheck false
		<= Head_code_label $mol_labeler
			title \Код вычисления заголовков
			Content <= Head_code $mol_textarea
				hint \return ['Дата', 'Значение']
				sidebar_showed true
				value? <=> head_code? \
				spellcheck false
		<= Rows_code_label $mol_labeler
			title \Код вычисления строк
			Content <= Rows_code $mol_textarea
				hint \return [['01.01.2026', 10]]
				sidebar_showed true
				value? <=> rows_code? \
				spellcheck false
		<= Rows_limit_field $mol_form_field
			name \Лимит строк
			Content <= Rows_limit $mol_number
				value? <=> rows_limit? 1000
				hint \0 - без лимита
				precision 1
				precision_change 1
		<= Columns_visibility_field $mol_form_field
			name \Видимость столбцов
			Content <= Columns_visibility $shm_check_list
				options <= column_visibility_options /string
				value? <=> columns_visible? /string
